<rt-group variant="horizontal" layout-justify-flex-end>
  <rt-follow-button
    [type]="'requisition'"
    [followed]="requisition.followed"
    (followClick)="follow.emit(requisition.id)"
    (unfollowClick)="unfollow.emit(requisition.id)"
  />
  @if (canEditRequisition) {
    <rt-icon-button
      #moreDropdownTrigger="rtOverlayOrigin"
      variant="plain"
      (click)="moreDropdown.open = !moreDropdown.open"
      [pressed]="moreDropdown.open"
      rt-overlay-origin
      iconName="more-horiz"
      shape="square"
    />
    <ng-template
      [origin]="moreDropdownTrigger"
      (backdropClick)="moreDropdown.open = false"
      #moreDropdown="rtConnectedOverlay"
      rt-connected-overlay
      hasBackdrop
    >
      <rt-dropdown [width]="DropdownWidth.Small">
        @if (requisition.status === RequisitionStatus.Pending) {
          <rt-dropdown-item (click)="cancelRequest.emit(requisition.id)">
            <rt-icon prefix name="cancel" />
            {{ 'app.requisitions.actions.cancel_approval_request' | translate }}
          </rt-dropdown-item>
        }
        @if (!requisition.archivedAt) {
          <rt-dropdown-item (click)="duplicate.emit(requisition.id)">
            <rt-icon prefix name="content-copy" />
            {{ 'app.offers.duplicate' | translate }}
          </rt-dropdown-item>
        }
        @if (!requisition.archivedAt) {
          <rt-dropdown-item (click)="archive.emit(requisition)">
            <rt-icon prefix name="archive" />
            {{ 'app.offers.archive' | translate }}
          </rt-dropdown-item>
        }
        @if (requisition.archivedAt) {
          <rt-dropdown-item (click)="retrieve.emit(requisition)">
            <rt-icon prefix name="archive" />
            {{ 'app.requisitions.actions.retrieve' | translate }}
          </rt-dropdown-item>
        }
        @if (!requisition.offersCount) {
          <rt-dropdown-item (click)="delete.emit(requisition)">
            <rt-icon prefix name="delete" />
            {{ 'app.common.delete' | translate }}
          </rt-dropdown-item>
        }
      </rt-dropdown>
    </ng-template>
  }
</rt-group>
